import { CompanyInitialState } from './companies-entities';
import { ContactInitialState } from './contact-entities';
export const InitialGinStepForm = {
    form_id: '',
    grant_id: '',
    deleted_at: undefined,
    pages: [],
    number_of_completed_steps: 0,
};
export var GinStepTargetUsers;
(function (GinStepTargetUsers) {
    GinStepTargetUsers["Admins"] = "admins";
    GinStepTargetUsers["Clients"] = "clients";
    GinStepTargetUsers["All"] = "all";
})(GinStepTargetUsers || (GinStepTargetUsers = {}));
export var GinStepItemFieldType;
(function (GinStepItemFieldType) {
    GinStepItemFieldType["TEXT"] = "text";
    GinStepItemFieldType["RICH_TEXT"] = "rich_text";
    GinStepItemFieldType["MEETING"] = "meeting";
    GinStepItemFieldType["PROPERTY"] = "property";
    GinStepItemFieldType["CHECKBOX"] = "checkbox";
    GinStepItemFieldType["EXAMPLE_ASSET"] = "example_asset";
    GinStepItemFieldType["ASSET_APPLICATION"] = "asset_application";
    GinStepItemFieldType["ASSET_BUCKET"] = "asset_bucket";
    GinStepItemFieldType["EMPTY"] = "";
})(GinStepItemFieldType || (GinStepItemFieldType = {}));
export var GinStepItemTargetUsers;
(function (GinStepItemTargetUsers) {
    GinStepItemTargetUsers["Admins"] = "admins";
    GinStepItemTargetUsers["Clients"] = "clients";
    GinStepItemTargetUsers["All"] = "all";
})(GinStepItemTargetUsers || (GinStepItemTargetUsers = {}));
export const InitialGinStepItem = {
    item_id: '',
    form_id: '',
    key: '',
    type: '',
    target_users: GinStepItemTargetUsers.Admins,
    tooltip_en: '',
    tooltip_fr: '',
    text: { admin_text_title_fr: '', admin_text_title_en: '', text_size: '' },
    rich_text: { rich_text_admin_content_fr: '', rich_text_admin_content_en: '' },
    meeting: { meeting_name: '' },
    property: { property_table: '', property_column: '' },
    checkbox: { admin_content_fr: '', admin_content_en: '' },
    example_asset: {
        step_asset_id: '',
        item_id: '',
        admin_id: '',
        asset_type: '',
        custom_asset_type: '',
        admin_name_en: '',
        admin_name_fr: '',
        deleted_at: undefined,
        file_response: undefined,
    },
    item_asset: {
        item_id: '',
        asset_type: '',
        custom_asset_type: '',
        admin_title_en: '',
        admin_title_fr: '',
        client_title_en: '',
        client_title_fr: '',
    },
    conditions: [],
};
export var ItemConditionType;
(function (ItemConditionType) {
    ItemConditionType["None"] = "none";
    ItemConditionType["Equals"] = "equals";
    ItemConditionType["NotEquals"] = "not equals";
    ItemConditionType["Empty"] = "empty";
    ItemConditionType["Filled"] = "filled";
    ItemConditionType["Greater"] = "greater";
    ItemConditionType["Lower"] = "lower";
    ItemConditionType["Contains"] = "contains";
    ItemConditionType["Required"] = "required";
    ItemConditionType["LinkOfType"] = "link of type";
})(ItemConditionType || (ItemConditionType = {}));
export const InitialGinStepCondition = {
    condition_id: '',
    item_id: '',
    page_id: '',
    condition_type: ItemConditionType.None,
    trigger_values: [],
};
export const InitialGinStepTriggerValue = {
    trigger_value_id: '',
    condition_id: '',
    trigger_value: '',
    deleted: false,
};
export const InitialAdminGinStepFormApplicationResponse = {
    form_application_id: '',
    form: InitialGinStepForm,
    form_sections: [],
    program_id: '',
};
export const InitialGinStepApplicationItem = {
    item_application_id: '',
    form_application_id: '',
    item_id: '',
};
export const InitialEditableGinStepFormApplicationResponse = {
    company: CompanyInitialState,
    contact: ContactInitialState,
    form: {
        entity: InitialGinStepForm,
        pages: [],
    },
    submission: InitialGinStepForm,
    all_items: [],
};
export const GinStepItemTextSizeValues = {
    small: {
        minRows: 1,
        maxRows: 3,
        charLimit: 200,
    },
    medium: {
        minRows: 4,
        maxRows: 6,
        charLimit: 400,
    },
    large: {
        minRows: 8,
        maxRows: 12,
        charLimit: 1000,
    },
};
export const FormLinkType = {
    fathom: { display: 'Fathom', domain: 'fathom' },
    drive: { display: 'Google Drive', domain: 'google' },
    hubspot: { display: 'Hubspot', domain: 'hubspot' },
};
